import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
export const refreshSession = () => {
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  return refreshing;
};

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retry && !(cfg.url || "").startsWith("/auth/")) {
      cfg._retry = true;
      try {
        await refreshSession();
        return api(cfg);
      } catch {
        /* refresh failed: fall through */
      }
    }
    return Promise.reject(error);
  },
);

export const mediaUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.message || JSON.stringify(d);
};
